// https://www.npmjs.com/package/react-rating
/**
 * === StarRating Component ===
 *
 * Компонент для отображения рейтинга
 *
 */

import React, { Component } from 'react';
import Rating from 'react-rating';
import PropTypes from 'prop-types';
import indexOf from 'lodash/indexOf';
import Bem from 'bemHelper';
import localStorage from 'helpers/local-storage';
import { I18nHoc } from 'helpers/i18n';
import numDesc from 'helpers/numDesc';
import { emit } from 'helpers/global-events';
import { reportError } from 'api/api-errors';
import apiDecorator from 'api/api-decorator';
import DataProvider from 'api/data-provider';
import Notification from 'components/notification';

import translates from './star-rating-i18n.json';

import 'styles/base/components/star-rating/_star-rating.scss';

const bemClasses = new Bem('ratingStars');

@apiDecorator
@I18nHoc(translates)
export default class StarRating extends Component {
  static propTypes = {
    className: PropTypes.string,
    entity: PropTypes.string.isRequired,
    entity_id: PropTypes.number.isRequired,
    withValue: PropTypes.bool,
    withVoice: PropTypes.bool,
    rating: PropTypes.number,
    // voted: PropTypes.number
  };

  static get defaultProps() {
    return {
      withVoice: true
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      voted: false
    }
  }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  onClick = (data) => {
    const { entity_id, entity } = this.props;
    const votedPublicationIds = localStorage.get(`${entity}starRatingIds`) || [];
    if (indexOf(votedPublicationIds, entity_id) > -1) {
      return Notification.error(this.i18n('alreadyVote'));
    }

    this.api.get('action/ratings/action/vote', {
      queryString: {
        entity,
        entity_id,
        rating: +data
      }
    })
      .then(() => {
        votedPublicationIds.push(entity_id);
        localStorage.emit(`${entity}starRatingIds`, votedPublicationIds);
        this.setState({ voted: true}, () => emit('updateRating'));
      })
      .catch(error => reportError(error));
  }

  rating = ({ data }) => {
    const { i18n } = this;
    const { withValue, withVoice } = this.props;
    const value = data[0] ? data[0].rating : 0;
    const voted = data[0] ? data[0].voted_count : 0;
    const bestRating = '10'; // TODO: вдруг это изменится - надо заменить везде в микроразметке на новое значение

    return (
      <>
        {withValue &&
          <span
            {...bemClasses('text', 'value')}
            children={`${Math.round(value * 4) / 2}/${bestRating}`}
          />
        }
        <Rating
          {...bemClasses('stars')}
          emptySymbol="icon icon_faStar"
          fullSymbol="icon icon_faStarFill"
          fractions={2}
          initialRating={Math.round(value * 2) / 2 }
          onClick={this.onClick}
        />
        {withVoice &&
          <span
            {...bemClasses('text', 'voice')}
            children={numDesc(voted || 0, i18n('voice_1'), i18n('voice_2'), i18n('voice_3'))}
          />
        }
      </>
    );
  }

  render() {
    const { className, rating, voted_count, entity, entity_id } = this.props;
    const { voted } = this.state;
    const isRating = (!!rating || rating === 0) && !voted;

    if (!this.state.mounted) return (
      <div {...bemClasses({ extra: className })}>
        {this.rating({data: [{rating, voted_count}]})}
      </div>
    );

    return (
      <div {...bemClasses({ extra: className })}>
        {!isRating &&
          <DataProvider
            cache={!voted ? 5 : 0}
            updateEvent="updateRating"
            url="common/rating/rating"
            query={{
              entity: entity,
              entityId: entity_id
            }}
            renderer={this.rating}
          />
        }
        {isRating && this.rating({data: [{rating, voted_count}]})}
      </div>
    );
  }
}
